export const classesSlugs = [
	'zumba',
	'yoguitos',
	'yoga',
	'trx',
	'swim-coach',
	'step',
	'spinning',
	'rpm',
	'power-jump',
	'powerjump',
	'pilates',
	'phive-stretch',
	'natacao-kids',
	'natacaokids',
	'natacao-bebes',
	'natacaobebes',
	'musculacao',
	'mobilidade',
	'kangoo',
	'hidro-hiit',
	'hidrohiit',
	'hidro-ginastica',
	'hidroginastica',
	'hidro-bike',
	'hidrobike',
	'grit-strength',
	'gritstrength',
	'grit-plyo',
	'gritplyo',
	'grit-bootcamp',
	'gritbootcamp',
	'ginastica_acrobatica',
	'ginasticaacrobatica',
	'gap',
	'flyoga',
	'aqua-circuit',
	'aquacircuit',
	'ballet',
	'body-attack',
	'bodyattack',
	'body-balance',
	'bodybalance',
	'body-combat',
	'bodycombat',
	'body-jam',
	'bodyjam',
	'body-pump',
	'bodypump',
	'body-step',
	'bodystep',
	'bodyvive',
	'bootcamp',
	'born-to-move',
	'borntomove',
	'btm',
	'crossphit',
	'cx-work',
]

export const classesColors = [
	{
		slug: 'zumba',
		color: '#000000',
	},
	{
		slug: 'yoguitos',
		color: '#000000',
	},
	{
		slug: 'yoga',
		color: '#000000',
	},
	{
		slug: 'trx',
		color: '#000000',
	},
	{
		slug: 'swim-coach',
		color: '#000000',
	},
	{
		slug: 'step',
		color: '#000000',
	},
	{
		slug: 'spinning',
		color: '#000000',
	},
	{
		slug: 'rpm',
		color: '#000000',
	},
	{
		slug: 'power-jump',
		color: '#000000',
	},
	{
		slug: 'pilates',
		color: '#000000',
	},
	{
		slug: 'phive-stretch',
		color: '#000000',
	},
	{
		slug: 'natacao-kids',
		color: '#000000',
	},
	{
		slug: 'natacao-bebes',
		color: '#000000',
	},
	{
		slug: 'musculacao',
		color: '#000000',
	},
	{
		slug: 'mobilidade',
		color: '#000000',
	},
	{
		slug: 'kangoo',
		color: '#000000',
	},
	{
		slug: 'hidro-hiit',
		color: '#000000',
	},
	{
		slug: 'hidro-ginastica',
		color: '#000000',
	},
	{
		slug: 'hidro-bike',
		color: '#000000',
	},
	{
		slug: 'grit-strength',
		color: '#000000',
	},
	{
		slug: 'grit-plyo',
		color: '#000000',
	},
	{
		slug: 'grit-bootcamp',
		color: '#000000',
	},
	{
		slug: 'ginastica_acrobatica',
		color: '#000000',
	},
	{
		slug: 'gap',
		color: '#000000',
	},
	{
		slug: 'flyoga',
		color: '#000000',
	},
	{
		slug: 'aqua-circuit',
		color: '#000000',
	},
	{
		slug: 'ballet',
		color: '#000000',
	},
	{
		slug: 'body-attack',
		color: '#000000',
	},
	{
		slug: 'body-balance',
		color: '#000000',
	},
	{
		slug: 'body-combat',
		color: '#000000',
	},
	{
		slug: 'body-jam',
		color: '#000000',
	},
	{
		slug: 'body-pump',
		color: '#000000',
	},
	{
		slug: 'body-step',
		color: '#000000',
	},
	{
		slug: 'bodyvive',
		color: '#000000',
	},
	{
		slug: 'bootcamp',
		color: '#000000',
	},
	{
		slug: 'born-to-move',
		color: '#000000',
	},
	{
		slug: 'btm',
		color: '#000000',
	},
	{
		slug: 'crossphit',
		color: '#000000',
	},
	{
		slug: 'cx-work',
		color: '#000000',
	},
]
